var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path5, _path6, _path7, _path8, _path9, _path10, _circle4, _circle5, _circle6, _circle7, _circle8, _polygon, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path11, _polygon2, _path12, _path13, _polygon3, _path14, _polygon4, _circle9, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawPresentationReSxof(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 863.35926,
    height: 551.172,
    viewBox: "0 0 863.35926 551.172",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "af9c47ac-a2dc-4072-9acc-a467df334c71-440",
    "data-name": "Path 438",
    d: "M1009.5389,675.54135a24.21464,24.21464,0,0,1-23.38269-4.11877c-8.18977-6.87442-10.758-18.196-12.8467-28.68191l-6.17973-31.01657,12.93769,8.90836c9.30465,6.40642,18.81827,13.01866,25.26012,22.29786s9.25223,21.94707,4.07792,31.988",
    transform: "translate(-168.32037 -174.414)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a2175a99-769b-4e22-9c2a-ba3916b1dd51-441",
    "data-name": "Path 439",
    d: "M1007.54119,715.25191c1.62839-11.86369,3.30382-23.88079,2.15884-35.87167-1.01467-10.64933-4.26373-21.04881-10.87831-29.57938a49.20592,49.20592,0,0,0-12.62466-11.44039c-1.26215-.79648-2.42409,1.20354-1.16733,1.997a46.77938,46.77938,0,0,1,18.50445,22.32562c4.02858,10.24607,4.67546,21.41582,3.98155,32.3003-.41944,6.58217-1.31074,13.1212-2.20588,19.65251a1.19816,1.19816,0,0,0,.808,1.4225,1.16348,1.16348,0,0,0,1.42253-.808Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "af3ce5ac-a957-487e-9ef8-bdcad0da5bae-442",
    "data-name": "Path 442",
    d: "M995.82016,696.21546a17.82511,17.82511,0,0,1-15.53141,8.01861c-7.86441-.37318-14.41807-5.85972-20.31713-11.07026l-17.452-15.4088,11.54987-.55281c8.30619-.39784,16.82672-.771,24.73813,1.79338s15.20758,8.72639,16.654,16.91541",
    transform: "translate(-168.32037 -174.414)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "baa57c63-949d-49ac-a818-33ae8c022157-443",
    "data-name": "Path 443",
    d: "M1012.14417,722.0716c-7.83972-13.87143-16.93234-29.288-33.1808-34.21552a37.02609,37.02609,0,0,0-13.95545-1.44105c-1.48189.128-1.1118,2.41174.367,2.28454a34.39821,34.39821,0,0,1,22.27164,5.89215c6.27994,4.27453,11.16975,10.21755,15.30781,16.51907,2.53511,3.86051,4.80576,7.88445,7.07642,11.903C1010.75635,724.2983,1012.87818,723.37076,1012.14417,722.0716Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#f2f2f2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "b0eb2d2e-6002-4ca6-b573-2a3a0ae57324",
    "data-name": "Rectangle 62",
    x: 0.22681,
    y: 14.58304,
    width: 531.92378,
    height: 252.40706,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "b22521a2-b305-47e5-91b3-f89bb30cedaf",
    "data-name": "Rectangle 75",
    x: 15.43735,
    y: 36.22739,
    width: 501.50345,
    height: 210.5911,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "b9a97102-17ad-4853-bba8-52d2fbac14c1",
    "data-name": "Rectangle 80",
    width: 531.92378,
    height: 22.5977,
    fill: "#4d21ed"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "f3a384f8-0054-45a4-b875-f53a31bc49a8",
    "data-name": "Ellipse 90",
    cx: 16.7929,
    cy: 13.28795,
    r: 4.1884,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a6ee8772-6be5-4bf0-b917-98ef2062699d",
    "data-name": "Ellipse 91",
    cx: 32.69069,
    cy: 13.28795,
    r: 4.1884,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "a71cc61a-5bfc-4a03-b945-2c535d93104d",
    "data-name": "Ellipse 92",
    cx: 48.58921,
    cy: 13.28795,
    r: 4.1884,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M660.64368,378.58113H411.98486a.77823.77823,0,0,1-.77819-.77819V258.62077a.77819.77819,0,0,1,1.55638,0v118.404H660.64368a.77819.77819,0,0,1,0,1.55638Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M465.11242,370.02105H442.49593a2.31263,2.31263,0,0,1-2.31-2.30987V336.53424a2.31263,2.31263,0,0,1,2.31-2.30986h22.61649a2.31263,2.31263,0,0,1,2.31006,2.30986v31.17694A2.31263,2.31263,0,0,1,465.11242,370.02105Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#4d21ed"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M506.35642,370.02105H483.73993a2.31264,2.31264,0,0,1-2.31006-2.30987V306.96307a2.31264,2.31264,0,0,1,2.31006-2.30986h22.61649a2.31263,2.31263,0,0,1,2.31006,2.30986v60.74811A2.31263,2.31263,0,0,1,506.35642,370.02105Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#4d21ed"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M547.60042,370.02105H524.98393a2.31263,2.31263,0,0,1-2.31006-2.30987V336.53424a2.31263,2.31263,0,0,1,2.31006-2.30986h22.61649a2.31263,2.31263,0,0,1,2.31005,2.30986v31.17694A2.31263,2.31263,0,0,1,547.60042,370.02105Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#4d21ed"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M588.84441,370.02105H566.22793a2.26208,2.26208,0,0,1-2.31006-2.20522V295.1856a2.26208,2.26208,0,0,1,2.31006-2.20522h22.61648a2.26208,2.26208,0,0,1,2.31006,2.20522v72.63023A2.26208,2.26208,0,0,1,588.84441,370.02105Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#4d21ed"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M630.08841,370.02105H607.47192a2.31263,2.31263,0,0,1-2.31-2.30987v-93.432a2.31264,2.31264,0,0,1,2.31-2.30987h22.61649a2.31264,2.31264,0,0,1,2.31006,2.30987v93.432A2.31263,2.31263,0,0,1,630.08841,370.02105Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#4d21ed"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.48381,
    cy: 145.80298,
    r: 4.66913,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.7278,
    cy: 115.45363,
    r: 4.66913,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 367.9718,
    cy: 145.80298,
    r: 4.66913,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.2158,
    cy: 100.66804,
    r: 4.66913,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 450.4598,
    cy: 83.54789,
    r: 4.66913,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "368.07 146.849 326.728 115.883 285.95 146.426 285.017 145.18 326.728 113.938 367.873 144.757 408.761 100.013 408.925 99.946 450.169 83.328 450.751 84.772 409.671 101.323 368.07 146.849",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 61.96731,
    width: 70.63054,
    height: 5.30876,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 77.55204,
    width: 109.06894,
    height: 5.30875,
    fill: "#4d21ed"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 73.26117,
    y: 92.39442,
    width: 88.88879,
    height: 5.30875,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 108.67991,
    width: 51.89183,
    height: 5.30875,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 124.58739,
    width: 78.31823,
    height: 5.30875,
    fill: "#4d21ed"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 60.29736,
    width: 8.64865,
    height: 8.64864,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 75.88208,
    width: 8.64865,
    height: 8.64863,
    fill: "#4d21ed"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 90.72448,
    width: 8.64865,
    height: 8.64865,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 107.00997,
    width: 8.64865,
    height: 8.64865,
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 122.91744,
    width: 8.64865,
    height: 8.64865,
    fill: "#4d21ed"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 140.5943,
    width: 70.63054,
    height: 5.30875,
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 156.17905,
    width: 109.06894,
    height: 5.30875,
    fill: "#4d21ed"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 73.26117,
    y: 171.02142,
    width: 88.88879,
    height: 5.30875,
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 187.30691,
    width: 51.89183,
    height: 5.30875,
    fill: "#e6e6e6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 72.12712,
    y: 203.21439,
    width: 78.31823,
    height: 5.30875,
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 138.92436,
    width: 8.64865,
    height: 8.64865,
    fill: "#e6e6e6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 154.50908,
    width: 8.64865,
    height: 8.64863,
    fill: "#4d21ed"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 169.35148,
    width: 8.64865,
    height: 8.64865,
    fill: "#e6e6e6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 185.63697,
    width: 8.64865,
    height: 8.64865,
    fill: "#e6e6e6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 39.93496,
    y: 201.54445,
    width: 8.64865,
    height: 8.64865,
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M813.89981,337.21642c2.97507-9.48142,9.74046-18.17745,19.09685-21.38268,9.35695-3.20524,25.67946-.20914,30.09216,8.68789,6.35889,12.82263,3.50213,28.52557.13009,42.44794-1.75836-.09308-3.533-.16625-5.31263-.2329l-2.51754-8.39087V366.654c-13.89076-.42928-28.35231-.1605-42.82171.11747C811.27013,356.91483,810.92474,346.69784,813.89981,337.21642Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "773.219 524.09 761.533 528.987 737.084 486.247 754.33 479.019 773.219 524.09",
    fill: "#ffb7b7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M949.26623,708.582l-37.67754,15.79009-.19974-.47656a15.90176,15.90176,0,0,1,8.51854-20.81117l.00093-.00039,23.01219-9.644Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M770.17936,496.60793a8.76574,8.76574,0,0,1,3.55637-12.9622l25.1152-75.78554,16.82,8.971L785.69455,488.505a8.81325,8.81325,0,0,1-15.51519,8.1029Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#ffb7b7"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "632.825 537.677 620.155 537.676 614.128 488.807 632.827 488.808 632.825 537.677",
    fill: "#ffb7b7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M804.37626,724.37206l-40.85247-.00152v-.51672a15.90177,15.90177,0,0,1,15.90092-15.90066h.001l24.9513.001Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "683.623 259.72 686.494 267.184 685.92 274.648 630.801 267.759 632.524 261.443 638.839 253.979 683.623 259.72",
    fill: "#ffb7b7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 665.85899,
    cy: 172.48496,
    r: 20.06685,
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M855.11916,442.13336l-54.65674-5.814-2.36816-7.74414c-.73584-1.00879-7.67334-10.84082-6.13477-20.66943a17.11819,17.11819,0,0,1,7.39527-11.46241l13.28906-15.56006,11.69067-6.959,23.04712-2.3042.07935.01758,20.69067,4.68213-.251,37.92773Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M801.83937,446.1529l-15.31347-1.81836.04-.481c.14087-1.69092,3.49-41.51367,6.91992-50.66016,3.50391-9.34326,18.67993-12.2539,19.32422-12.373l.186-.03418,3.37281,2.02343-9.30713,29.085Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M854.81459,446.19166v12.7535s14.92805,19.39923,6.88987,34.32729c0,0,17.22467,32.15273,18.373,43.63585l16.07636,52.82234s40.19092,40.19092,36.746,68.89871l2.29662,9.1865L908.78524,679.299l-5.74156-8.03818-44.78416-76.93689-37.89429-70.047-6.88987,82.67845s4.59325,64.30546-8.03818,71.19533l-1.14832,10.33481H777.48437v-9.82394s-9.94148-34.96022-4.19993-61.37139l-2.29662-111.38625s10.33481-47.08079,22.96624-55.119l4.59325-11.48312Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M835.72628,472.56038a9.02766,9.02766,0,0,1,1.358.41978l35.03179-24.11374-.80161-10.30066,15.38739-3.24161,3.19125,18.09738a6.86041,6.86041,0,0,1-3.72174,7.34421l-43.39415,21.401a9.00181,9.00181,0,1,1-7.05092-9.60637Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#ffb7b7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M871.78518,450.19782,864.65505,402.63l-5.85278-24.57276,8.74487-1.82763c.238-.08838,7.35815-2.49512,13.10693,1.38037,4.13794,2.78955,6.43018,8.08349,6.8125,15.73437l2.31641,54.43018Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M820.391,320.76838a25.20457,25.20457,0,0,1,38.31986,21.99693c-11.21678.51584-22.99987.65013-34.94781.67333l-2.82368-6.91076-1.66472,6.91587q-5.46093-.00053-10.9426-.01436A25.7352,25.7352,0,0,1,820.391,320.76838Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.67963,725.586h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-168.32037 -174.414)",
    fill: "#cbcbcb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawPresentationReSxof);
export default __webpack_public_path__ + "static/media/undraw_presentation_re_sxof.d8a34f73ec60eab6c82e6d56e374bf1f.svg";
export { ForwardRef as ReactComponent };